import axiosClient from "./AxiosClient";
import { API_BASE_URL } from "../config";

// Generic types kept for backward compatibility (if used elsewhere)
import { FeedbackRequest, FeedbackResponse } from "../types/FeedbackTypes";

type CreateFeedbackPayload = {
  feedback: string;
  rating: boolean; // true for like, false for dislike
  session_id: string;
  message_id: string;
};

const FeedbackApi = {
  // Legacy endpoint (if used somewhere else)
  submitFeedback: (data: FeedbackRequest) =>
    axiosClient.post<FeedbackResponse>("/feedback", data),

  // New endpoint matching provided cURL. Uses axiosClient for consistency.
  create: async (
    payload: CreateFeedbackPayload,
    options?: { accessToken?: string; absoluteUrl?: string },
  ) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/feedback/create`;
    return axiosClient.post(url, payload);
  },
};

export type { CreateFeedbackPayload };
export default FeedbackApi;
